import { render, staticRenderFns } from "./IndexFooter.vue?vue&type=template&id=d84befba&scoped=true&"
import script from "./IndexFooter.vue?vue&type=script&lang=js&"
export * from "./IndexFooter.vue?vue&type=script&lang=js&"
import style0 from "./IndexFooter.vue?vue&type=style&index=0&id=d84befba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84befba",
  null
  
)

export default component.exports